import Vue from 'vue'
import vueSmoothScroll from 'vue2-smooth-scroll'

import App from './App.vue'
import './registerServiceWorker'

import './style/main.scss'
import './assets/svg/logo.svg?sprite'
import './assets/svg/logoen.svg?sprite'
import './assets/svg/red-line.svg?sprite'
import './assets/svg/arrow.svg?sprite'
import './assets/svg/map-pathway.svg?sprite'
import './assets/svg/map-pathwayen.svg?sprite'
import './assets/icon/fb.svg?sprite'
import './assets/icon/vk.svg?sprite'

Vue.config.productionTip = false

Vue.use(vueSmoothScroll)

new Vue({
  render: h => h(App)
}).$mount('#app')
